import React from 'react';
import { CargoDetails } from '@api/features/cargos/getCargoDetails';
import { Port } from '@api/utils/ports';

type CargoMarkersLayerProps = {
	cargos: CargoDetails[];
	selectedLoadingPortId: number | null;
	renderMarker: (port: Port, isSelected: boolean) => React.ReactNode;
};
const CargoMarkersLayer = ({
	cargos,
	selectedLoadingPortId,
	renderMarker,
}: CargoMarkersLayerProps) => {
	const ports = Array.from(
		new Map(
			cargos
				.map((c) => c.loadingPorts?.[0])
				.filter((p): p is Port => p != null)
				.map((p) => [p.id, p])
		).values()
	);

	return (
		<>
			{ports.map((port) => (
				renderMarker(
					port,
					port.id === selectedLoadingPortId,
				)
			))}
		</>
	);
};

export default CargoMarkersLayer;